import { Component } from '@angular/core';
import { TitleService } from '../../../services/title.service';
import { Corso } from '../../../models/corso.model';
import { CommonModule, KeyValue } from '@angular/common';
import { Router } from '@angular/router';

@Component({
  selector: 'app-corsi',
  imports: [CommonModule],
  templateUrl: './corsi.component.html',
  styleUrl: './corsi.component.css'
})
export class CorsiComponent {

  corsi: Array<Corso> = [
    { nome: "POSTURALE", nomeFoto: "posturale.jpg" },
    { nome: "PILATES", nomeFoto: "pilates.jpg" },
    { nome: "YOGA MOBILITY", nomeFoto: "yoga.jpg" },
    { nome: "MOBILITY FLOW", nomeFoto: "yoga.jpg" },
    { nome: "CROSS TRAINING", nomeFoto: "cross.jpg" },
    { nome: "BOOTY WORKOUT", nomeFoto: "booty.jpg" },
    { nome: "KETTLEBELL WORKOUT", nomeFoto: "kettlebell.jpg" },
    { nome: "TONE", nomeFoto: "tonificazione.jpg" },
    { nome: "TOTAL BODY", nomeFoto: "fatburn.jpg" },
    { nome: "KICKBOXING", nomeFoto: "kick.jpg" },
    { nome: "SALSA", nomeFoto: "salsa.jpg" },
    { nome: "BACHATA", nomeFoto: "bachata.jpg" }
  ];

  giornoSel: number = 0;
  giorni: Array<KeyValue<number, String>> =
    [
      { key: 0, value: "Lunedì" },
      { key: 1, value: "Martedì" },
      { key: 2, value: "Mercoledì" },
      { key: 3, value: "Giovedì" },
      { key: 4, value: "Venerdì" },
      { key: 5, value: "Sabato" }/* ,
    {key: 6, value: "Domenica"} */
    ]

  orari: Array<Array<Corso>> =
    [
      [
        { nome: "POSTURALE", pianificazione: { oraInizio: "8:00", oraFine: "9:00" }, istruttore: "Antonio Vannacci", urlIstruttore: "" },
        { nome: "BOOTY WORKOUT", pianificazione: { oraInizio: "18:00", oraFine: "19:00" }, istruttore: "Federica Peluso", urlIstruttore: "" },
        { nome: "KICKBOXING", pianificazione: { oraInizio: "19:00", oraFine: "20:00" }, istruttore: "Valerio Olivieri", urlIstruttore: "" },
        { nome: "SALSA", pianificazione: { oraInizio: "20:00", oraFine: "21:00" }, istruttore: "Monia Catena e Fabrizio Bellucci", urlIstruttore: "" },
        { nome: "BACHATA", pianificazione: { oraInizio: "21:00", oraFine: "22:00" }, istruttore: "Monia Catena e Fabrizio Bellucci", urlIstruttore: "" }
      ],
      [
        { nome: "PILATES", pianificazione: { oraInizio: "9:00", oraFine: "10:00" }, istruttore: "Gianni Labarbuta", urlIstruttore: "" },
        { nome: "YOGA MOBILITY", pianificazione: { oraInizio: "10:00", oraFine: "11:00" }, istruttore: "Rosa Zampetti", urlIstruttore: "" },
        { nome: "TOTAL BODY", pianificazione: { oraInizio: "17:00", oraFine: "18:00" }, istruttore: "Rosa Zampetti", urlIstruttore: "" },
        { nome: "PILATES", pianificazione: { oraInizio: "18:00", oraFine: "19:00" }, istruttore: "Antonio Vannacci", urlIstruttore: "" },
        { nome: "CROSS TRAINING", pianificazione: { oraInizio: "19:00", oraFine: "20:00" }, istruttore: "Rosa Zampetti", urlIstruttore: "" },
        { nome: "CROSS TRAINING", pianificazione: { oraInizio: "20:00", oraFine: "21:00" }, istruttore: "Rosa Zampetti", urlIstruttore: "" }
      ],
      [
        { nome: "TONE", pianificazione: { oraInizio: "9:00", oraFine: "10:00" }, istruttore: "Rosa Zampetti", urlIstruttore: "" },
        { nome: "BOOTY WORKOUT", pianificazione: { oraInizio: "18:00", oraFine: "19:00" }, istruttore: "Federica Peluso", urlIstruttore: "" },
        { nome: "KICKBOXING", pianificazione: { oraInizio: "19:00", oraFine: "20:00" }, istruttore: "Valerio", urlIstruttore: "" },
        { nome: "PILATES", pianificazione: { oraInizio: "20:00", oraFine: "21:00" }, istruttore: "", urlIstruttore: "" }
      ],
      [
        { nome: "PILATES", pianificazione: { oraInizio: "9:00", oraFine: "10:00" }, istruttore: "Gianni Labarbuta", urlIstruttore: "" },
        { nome: "YOGA MOBILITY", pianificazione: { oraInizio: "10:00", oraFine: "11:00" }, istruttore: "Rosa Zampetti", urlIstruttore: "" },
        { nome: "TOTAL BODY", pianificazione: { oraInizio: "17:00", oraFine: "18:00" }, istruttore: "Rosa Zampetti", urlIstruttore: "" },
        { nome: "PILATES", pianificazione: { oraInizio: "18:00", oraFine: "19:00" }, istruttore: "Antonio Vannacci", urlIstruttore: "" },
        { nome: "CROSS TRAINING", pianificazione: { oraInizio: "19:00", oraFine: "20:00" }, istruttore: "Rosa Zampetti", urlIstruttore: "" }
      ],
      [
        { nome: "POSTURALE", pianificazione: { oraInizio: "8:00", oraFine: "9:00" }, istruttore: "Antonio Vannacci", urlIstruttore: "" },
        { nome: "KICKBOXING", pianificazione: { oraInizio: "18:00", oraFine: "19:00" }, istruttore: "Valerio Olivieri", urlIstruttore: "" },
        { nome: "KICKBOXING", pianificazione: { oraInizio: "19:00", oraFine: "20:00" }, istruttore: "Valerio Olivieri", urlIstruttore: "" },
        { nome: "MOBILITY FLOW", pianificazione: { oraInizio: "20:00", oraFine: "21:00" }, istruttore: "Viola Spera", urlIstruttore: "" }
      ],
      [
        { nome: "MOBILITY FLOW", pianificazione: { oraInizio: "9:00", oraFine: "10:00" }, istruttore: "Viola Spera", urlIstruttore: "" },
        { nome: "CROSS TRAINING", pianificazione: { oraInizio: "11:00", oraFine: "12:00" }, istruttore: "Rosa Zampetti", urlIstruttore: "" }
      ],
      []
    ]

  constructor(private ts: TitleService, public router: Router) { }

  ngOnInit() {
    this.ts.titolo = "Corsi";
  }
}
